import type { VerticalBeamPosition } from "./layoutMeta";

const standingLayoutNames = {
  left: "Staander links",
  middle: "Staander midden",
  right: "Staander rechts",
};

export const getStaanderPositionName = (
  position: VerticalBeamPosition,
): string => standingLayoutNames[position];

export const formatLayoutVariantCount = (count: number): string =>
  `${count} ${count === 1 ? "variant" : "varianten"}`;
